import React, { useState } from "react";
import styles from "../../../assets/styles/AuthComponents.module.scss";
import { useNavigate } from "react-router-dom";
import Input from "../../../components/common/input/Input";
import { useAuth } from "../../../context/AuthContext";
import AuthHeader from "../../../components/common/header/auth-header/AuthHeader";
import AuthService from "../../../api/services/auth.service";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import { useTranslation } from "react-i18next";

const ConfirmPassword = () => {
  const { t } = useTranslation("translation");
  const { email } = useAuth();
  const [passwordValue, setPasswordValue] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessages, setErrorMessages] = useState<{
    code?: string;
    password?: string;
  }>({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const errors: typeof errorMessages = {};
    if (!codeValue) errors.code = t("required.verify_code") || "";
    if (!passwordValue) errors.password = t("required.password") || "";

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("code", codeValue);
      formData.append("new_password", passwordValue);

      await AuthService.confirmForgetPassword(formData);
      navigate("/auth/login");
    } catch (error: any) {
      setLoading(false);
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("error_message");
      setErrorMessage(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <TitleUpdater title={t("labels.confrim_password")} />
      <form className={styles.form} onSubmit={handleSubmit}>
        <AuthHeader
          onBackClick={() => navigate("/auth/forget-password")}
          title={t("otp.reset_password")}
        />
        {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
        <Input
          label={t("labels.otp_code") || ""}
          placeholder={t("placeholders.otp_code") || ""}
          type="text"
          id="code"
          value={codeValue}
          onChange={(e) => {
            setCodeValue(e.target.value);
            setErrorMessage("");
            setErrorMessages((prev) => ({ ...prev, code: "" }));
          }}
          error={errorMessages.code}
        />

        <Input
          label={t("labels.new_password") || ""}
          type="password"
          id="password"
          placeholder="••••••••••"
          value={passwordValue}
          onChange={(e) => {
            setPasswordValue(e.target.value);
            setErrorMessage("");
            setErrorMessages((prev) => ({ ...prev, password: "" }));
          }}
          error={errorMessages.password}
        />
        <button type="submit" className={styles.button} disabled={loading}>
          {loading ? t("buttons.loading") : t("submit")}
        </button>
      </form>
    </div>
  );
};

export default ConfirmPassword;
